(function () {
  const selectors = {
    addonsRoot: '[data-cp-product-addons]',
    addonsList: '[data-cp-addon-list]',
    addonCard: '[data-cp-addon-card]',
    addonToggle: '[data-cp-addon-toggle]',
    addonVariant: '[data-cp-addon-variant]',
    addonSwatch: '[data-cp-addon-swatch]',
    addonPriceCurrent: '[data-cp-addon-price-current]',
    addonPriceCompare: '[data-cp-addon-price-compare]',
    addonStatus: '[data-cp-addon-status]',
    addonImageLink: '[data-cp-addon-image-link]',
    sectionStoreHost: 'section-store--product-addons-block',
    addToCartButton: '.add_to_cart',
    ajaxSubmit: '.ajax-submit'
  };

  function parseBoolean(value) {
    return value === true || value === 'true';
  }

  function getClosestProductScope(node) {
    if (!node || typeof node.closest !== 'function') {
      return null;
    }

    return node.closest('.product-main') || node.closest('.js-product-section') || node.closest('.shopify-section');
  }

  function getAddonsRootForNode(node) {
    const scope = getClosestProductScope(node);

    if (!scope) {
      return null;
    }

    return scope.querySelector(selectors.addonsRoot);
  }

  function getSelectedAddonCards(addonsRoot) {
    if (!addonsRoot) {
      return [];
    }

    return Array.from(addonsRoot.querySelectorAll(selectors.addonCard)).filter(card => {
      const checkbox = card.querySelector(selectors.addonToggle);
      return checkbox && checkbox.checked && !checkbox.disabled;
    });
  }

  function getSectionStoreHostsForNode(node) {
    const form = node instanceof HTMLFormElement
      ? node
      : (node && typeof node.closest === 'function' ? node.closest('form') : null);
    const scope = getClosestProductScope(node);
    const scopedHosts = scope ? Array.from(scope.querySelectorAll(selectors.sectionStoreHost)) : [];

    if (scopedHosts.length) {
      return scopedHosts;
    }

    if (form && typeof form.id === 'string' && form.id.indexOf('sticky-product-form-form-') === 0) {
      return Array.from(document.querySelectorAll(selectors.sectionStoreHost));
    }

    return [];
  }

  function getSelectedSectionStoreAddonItems(node) {
    const itemsByVariantId = new Map();

    getSectionStoreHostsForNode(node).forEach(host => {
      const shadowRoot = host && host.shadowRoot;

      if (!shadowRoot) {
        return;
      }

      shadowRoot.querySelectorAll('.addons-box').forEach(box => {
        const toggle = box.querySelector('.addon-toggle-input');

        if (!(toggle && toggle.checked && !toggle.disabled)) {
          return;
        }

        const variantButton = box.querySelector('.product-variant-selector button');
        const variantId = String(
          (variantButton && variantButton.dataset && variantButton.dataset.variantId)
          || box.dataset.variantId
          || ''
        ).trim();

        if (!variantId || itemsByVariantId.has(variantId)) {
          return;
        }

        itemsByVariantId.set(variantId, {
          id: variantId,
          quantity: 1
        });
      });
    });

    return Array.from(itemsByVariantId.values());
  }

  // Drop trailing zero decimals to match the Calypso no-trailing-zeros style
  // ($15.00 -> $15, but $15.50 stays). Handles either . or , as the separator,
  // and won't touch the thousands group (negative lookahead for another digit).
  function stripZeroCents(formatted) {
    return String(formatted).replace(/([.,])00(?!\d)/, '');
  }

  function formatMoney(cents, moneyFormat) {
    const safeCents = Number(cents) || 0;
    const format = moneyFormat || document.body.dataset.moneyFormat || '${{amount}}';

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return stripZeroCents(window.Shopify.formatMoney(safeCents, format));
    }

    const amount = safeCents / 100;
    const currency = document.body.dataset.shopCurrency || 'USD';

    return stripZeroCents(new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    }).format(amount));
  }

  function syncToggleState(card) {
    if (!card) {
      return;
    }

    const checkbox = card.querySelector(selectors.addonToggle);
    const isSelected = checkbox && checkbox.checked && !checkbox.disabled;

    card.classList.toggle('is-selected', Boolean(isSelected));
  }

  function syncAvailability(card, available) {
    if (!card) {
      return;
    }

    const isAvailable = parseBoolean(available);
    const checkbox = card.querySelector(selectors.addonToggle);
    const status = card.querySelector(selectors.addonStatus);

    card.classList.toggle('is-unavailable', !isAvailable);

    if (checkbox) {
      checkbox.disabled = !isAvailable;

      if (!isAvailable) {
        checkbox.checked = false;
      }
    }

    if (status) {
      status.hidden = isAvailable;
    }

    syncToggleState(card);
  }

  function updateAddonImage(card, imageUrl, lightboxUrl) {
    if (!card || !imageUrl) {
      return;
    }

    const image = card.querySelector('.cp-product-addon__image');
    const imageLink = card.querySelector(selectors.addonImageLink);

    if (!image) {
      return;
    }

    image.setAttribute('src', imageUrl);
    image.setAttribute('srcset', imageUrl);

    if (imageLink && lightboxUrl) {
      imageLink.setAttribute('href', lightboxUrl);
    }
  }

  function syncSwatchState(card, variantId) {
    if (!card) {
      return;
    }

    card.querySelectorAll(selectors.addonSwatch).forEach(swatch => {
      const isSelected = String(swatch.dataset.variantId || '') === String(variantId || '');
      swatch.classList.toggle('is-selected', isSelected);
      swatch.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });
  }

  function updateVariantCard(select, options = {}) {
    if (!select) {
      return;
    }

    const option = select.options[select.selectedIndex];
    const card = select.closest(selectors.addonCard);
    const preserveImage = Boolean(options && options.preserveImage);

    if (!card || !option) {
      return;
    }

    const currentPrice = card.querySelector(selectors.addonPriceCurrent);
    const comparePrice = card.querySelector(selectors.addonPriceCompare);
    const addonsRoot = card.closest(selectors.addonsRoot);
    const moneyFormat = (addonsRoot && addonsRoot.dataset.moneyFormat) || document.body.dataset.moneyFormat;
    const variantId = option.value;
    const price = Number(option.dataset.price || 0);
    const compareAtPrice = Number(option.dataset.comparePrice || 0);
    const isAvailable = parseBoolean(option.dataset.available);
    const showComparePrice = parseBoolean(card.dataset.showComparePrice);

    card.dataset.selectedVariantId = variantId;

    if (currentPrice) {
      currentPrice.textContent = formatMoney(price, moneyFormat);
    }

    if (comparePrice) {
      const shouldShowCompare = showComparePrice && compareAtPrice > price;
      comparePrice.hidden = !shouldShowCompare;
      comparePrice.textContent = shouldShowCompare ? formatMoney(compareAtPrice, moneyFormat) : '';
    }

    if (!preserveImage) {
      updateAddonImage(card, option.dataset.imageUrl, option.dataset.imageLightboxUrl);
    }

    syncSwatchState(card, variantId);
    syncAvailability(card, isAvailable);
  }

  async function fetchRelatedAddonMarkup(addonsRoot, url) {
    if (!addonsRoot || !url) {
      return null;
    }

    const blockId = String(addonsRoot.dataset.blockId || '').trim();

    if (!blockId) {
      return null;
    }

    const response = await fetch(url, {
      headers: {
        Accept: 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!response.ok) {
      throw new Error('Unable to load related add-ons.');
    }

    const markup = await response.text();
    const parsed = new DOMParser().parseFromString(markup, 'text/html');
    const fallbackRoot = parsed.querySelector(`${selectors.addonsRoot}[data-block-id="${blockId}"]`);
    const fallbackList = fallbackRoot && fallbackRoot.querySelector(selectors.addonsList);

    if (!(fallbackList && fallbackList.querySelector(selectors.addonCard))) {
      return null;
    }

    return fallbackList.innerHTML;
  }

  async function loadRelatedFallback(addonsRoot) {
    if (!addonsRoot || addonsRoot.querySelector(selectors.addonCard)) {
      if (addonsRoot) {
        addonsRoot.hidden = false;
      }
      return;
    }

    const list = addonsRoot.querySelector(selectors.addonsList);
    const relatedUrl = String(addonsRoot.dataset.relatedUrl || '').trim();
    const state = String(addonsRoot.dataset.relatedState || 'idle').trim();

    if (!list || !relatedUrl || state === 'loading' || state === 'loaded') {
      return;
    }

    addonsRoot.dataset.relatedState = 'loading';

    try {
      const relatedMarkup = await fetchRelatedAddonMarkup(addonsRoot, relatedUrl);

      if (!relatedMarkup) {
        addonsRoot.dataset.relatedState = 'loaded';
        return;
      }

      list.innerHTML = relatedMarkup;
      list.hidden = false;
      addonsRoot.hidden = false;
      addonsRoot.dataset.addonSource = 'related';

      const emptyState = addonsRoot.querySelector('.cp-product-addons__empty');

      if (emptyState) {
        emptyState.hidden = true;
      }

      initializeAddonCards(addonsRoot);
      addonsRoot.dataset.relatedState = 'loaded';
    } catch (error) {
      addonsRoot.dataset.relatedState = 'error';
    }
  }

  function getMainItemFromForm(form) {
    if (!form) {
      return null;
    }

    const formData = new FormData(form);
    const properties = {};
    const item = {
      id: '',
      quantity: 1
    };

    for (const [name, value] of formData.entries()) {
      if (typeof value !== 'string') {
        continue;
      }

      if (name === 'id') {
        item.id = value;
        continue;
      }

      if (name === 'quantity') {
        const parsedQuantity = parseInt(value, 10);
        item.quantity = Number.isFinite(parsedQuantity) && parsedQuantity > 0 ? parsedQuantity : 1;
        continue;
      }

      if (name === 'selling_plan' && value) {
        item.selling_plan = value;
        continue;
      }

      if (name.startsWith('properties[') && name.endsWith(']')) {
        const propertyName = name.slice(11, -1);

        if (propertyName && value !== '') {
          properties[propertyName] = value;
        }
      }
    }

    if (Object.keys(properties).length) {
      item.properties = properties;
    }

    return item.id ? item : null;
  }

  function getAddonItems(addonsRoot, quantity) {
    return getSelectedAddonCards(addonsRoot)
      .map(card => {
        const variantId = card.dataset.selectedVariantId;

        if (!variantId) {
          return null;
        }

        return {
          id: variantId,
          quantity
        };
      })
      .filter(Boolean);
  }

  function getCombinedAddonItems(form, mainItem) {
    const itemsByVariantId = new Map();
    const addonsRoot = getAddonsRootForNode(form);
    const cpAddonItems = addonsRoot ? getAddonItems(addonsRoot, mainItem.quantity || 1) : [];
    const sectionStoreAddonItems = getSelectedSectionStoreAddonItems(form);

    cpAddonItems.concat(sectionStoreAddonItems).forEach(item => {
      const itemId = String(item && item.id ? item.id : '').trim();

      if (!itemId) {
        return;
      }

      itemsByVariantId.set(itemId, {
        id: itemId,
        quantity: Math.max(parseInt(item.quantity, 10) || 1, 1)
      });
    });

    return Array.from(itemsByVariantId.values());
  }

  function setButtonState(button, isBusy) {
    if (!button) {
      return;
    }

    if (isBusy) {
      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-busy', 'true');
      button.classList.add('disabled');
    } else {
      button.removeAttribute('disabled');
      button.removeAttribute('aria-busy');
      button.classList.remove('disabled');
    }
  }

  function clearWarnings() {
    document.querySelectorAll('.warning').forEach(warning => warning.remove());
  }

  function showWarning(form, message) {
    if (!form || !message) {
      return;
    }

    const warning = document.createElement('p');
    warning.className = 'warning animated bounceIn';
    warning.textContent = message.replace('All 1 ', 'All ');
    form.insertAdjacentElement('afterend', warning);
  }

  function getBundlePayload(form) {
    const mainItem = getMainItemFromForm(form);

    if (!mainItem) {
      return null;
    }

    const addonItems = getCombinedAddonItems(form, mainItem);

    if (!addonItems.length) {
      return null;
    }

    return {
      mainItem,
      addonItems
    };
  }

  function getCartAddUrl() {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return new URL('cart/add.js', `${window.location.origin}${root}`).toString();
  }

  async function submitBundle(form, button, bundlePayload) {
    const { mainItem, addonItems } = bundlePayload;
    const recipientForm = form.querySelector('[data-recipient-form]');

    clearWarnings();

    if (recipientForm) {
      recipientForm.classList.remove('recipient-form--has-errors');
    }

    setButtonState(button, true);

    try {
      const response = await fetch(getCartAddUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [mainItem].concat(addonItems)
        })
      });

      const payload = await response.json();

      if (!response.ok) {
        throw payload;
      }

      window.dispatchEvent(
        new CustomEvent('cart:item-added', {
          bubbles: true,
          detail: payload
        })
      );
    } catch (error) {
      if (error && error.errors && error.errors.email && recipientForm) {
        recipientForm.classList.add('recipient-form--has-errors');
      } else {
        showWarning(form, (error && error.description) || 'Unable to add these items to your cart.');
      }
    } finally {
      setButtonState(button, false);
    }
  }

  function maybeHandleForm(form, trigger) {
    if (!form) {
      return false;
    }

    const bundlePayload = getBundlePayload(form);

    if (!bundlePayload) {
      return false;
    }

    const addToCartButton =
      (trigger && trigger.closest && trigger.closest(selectors.addToCartButton)) ||
      form.querySelector(selectors.addToCartButton);

    submitBundle(form, addToCartButton, bundlePayload);
    return true;
  }

  document.addEventListener('change', event => {
    const variantSelect = event.target.closest(selectors.addonVariant);

    if (variantSelect) {
      updateVariantCard(variantSelect);
      return;
    }

    const toggle = event.target.closest(selectors.addonToggle);

    if (toggle) {
      syncToggleState(toggle.closest(selectors.addonCard));
    }
  });

  document.addEventListener('click', event => {
    const swatch = event.target.closest(selectors.addonSwatch);

    if (!swatch || swatch.disabled) {
      return;
    }

    const card = swatch.closest(selectors.addonCard);
    const select = card && card.querySelector(selectors.addonVariant);
    const variantId = String(swatch.dataset.variantId || '').trim();

    if (!select || !variantId) {
      return;
    }

    const matchingOption = Array.from(select.options).find(option => String(option.value) === variantId);

    if (!(matchingOption && !matchingOption.disabled)) {
      return;
    }

    select.value = variantId;
    updateVariantCard(select);
  });

  document.addEventListener(
    'click',
    event => {
      const ajaxSubmit = event.target.closest(selectors.ajaxSubmit);

      if (!ajaxSubmit) {
        return;
      }

      const form = ajaxSubmit.closest('form');

      if (!maybeHandleForm(form, ajaxSubmit)) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  document.addEventListener(
    'submit',
    event => {
      const form = event.target;

      if (!(form instanceof HTMLFormElement)) {
        return;
      }

      if (!maybeHandleForm(form, form.querySelector(selectors.addToCartButton))) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  function getAddonRoots(scope) {
    const searchRoot = scope || document;
    const roots = [];

    if (searchRoot.matches && searchRoot.matches(selectors.addonsRoot)) {
      roots.push(searchRoot);
    }

    return roots.concat(Array.from(searchRoot.querySelectorAll(selectors.addonsRoot)));
  }

  function initializeAddonCards(scope) {
    getAddonRoots(scope).forEach(addonsRoot => {
      addonsRoot.querySelectorAll(selectors.addonCard).forEach(card => {
        const variantSelect = card.querySelector(selectors.addonVariant);

        if (variantSelect) {
          updateVariantCard(variantSelect, { preserveImage: true });
        } else {
          syncAvailability(card, !card.classList.contains('is-unavailable'));
        }

        syncToggleState(card);
      });

      loadRelatedFallback(addonsRoot);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initializeAddonCards(document);
  });

  document.addEventListener('shopify:section:load', event => {
    initializeAddonCards(event.target);
  });
})();
